import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import app from 'flarum/forum/app';

export function addGameComposerAutocomplete() {
    let dropdown = null;
    let activeItems = [];
    let selectedIndex = 0;
    let mentionStart = 0;
    let searchTimeout = null;
    let isActive = false;
    let currentEditor = null;
    let $wrapper = null;

    function hideDropdown() {
        isActive = false;
        activeItems = [];
        if (dropdown) {
            dropdown.remove();
            dropdown = null;
        }
    }

    function showDropdown(items, editor) {
        activeItems = items;
        selectedIndex = 0;
        isActive = true;
        currentEditor = editor;

        if (!dropdown) {
            dropdown = document.createElement('div');
            dropdown.className = 'GameMention-autocomplete';
        }

        dropdown.innerHTML = '';
        items.forEach((item, i) => {
            const row = document.createElement('div');
            row.className = 'GameMention-autocomplete-item' + (i === 0 ? ' active' : '');

            if (item.image_url) {
                const img = document.createElement('img');
                img.src = item.image_url;
                img.alt = '';
                img.className = 'GameMention-autocomplete-image';
                row.appendChild(img);
            } else {
                const icon = document.createElement('span');
                icon.className = 'GameMention-autocomplete-icon';
                icon.textContent = '\u{1F3B2}';
                row.appendChild(icon);
            }

            const name = document.createElement('span');
            name.className = 'GameMention-autocomplete-name';
            name.textContent = item.name;
            row.appendChild(name);

            row.addEventListener('mousedown', (e) => {
                e.preventDefault();
                selectItem(item);
            });

            row.addEventListener('mouseenter', () => {
                selectedIndex = i;
                updateSelection();
            });

            dropdown.appendChild(row);
        });

        if ($wrapper && $wrapper[0]) {
            $wrapper[0].appendChild(dropdown);
        }
    }

    function updateSelection() {
        if (!dropdown) return;
        const items = dropdown.querySelectorAll('.GameMention-autocomplete-item');
        items.forEach((el, i) => {
            el.classList.toggle('active', i === selectedIndex);
        });
    }

    function selectItem(item) {
        if (!currentEditor) return;
        const replacement = 'jeu:\u201C' + item.name + '\u201D#' + item.id + ' ';
        currentEditor.replaceBeforeCursor(mentionStart, replacement);
        hideDropdown();
    }

    extend(TextEditor.prototype, 'oncreate', function () {
        $wrapper = this.$('.TextEditor-editor').parent();
    });

    extend(TextEditor.prototype, 'buildEditorParams', function (params) {
        const gameInputListener = () => {
            const editor = this.attrs.composer.editor;
            const selection = editor.getSelectionRange();
            const cursor = selection[0];

            if (selection[1] - cursor > 0) return;

            const lastChunk = editor.getLastNChars(50);

            // Look for jeu: pattern at the end of typed text
            const match = lastChunk.match(/jeu:\s?([\p{L}\p{N}\p{M}\s'_-]*)$/iu);

            if (!match) {
                if (isActive) hideDropdown();
                return;
            }

            const query = match[1].trim();
            // mentionStart = absolute position in text where "jeu:" begins
            mentionStart = cursor - lastChunk.length + match.index;

            if (query.length < 2) {
                if (isActive) hideDropdown();
                return;
            }

            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                app.request({
                    method: 'GET',
                    url: app.forum.attribute('apiUrl') + '/game-mentions',
                    params: { search: query },
                }).then(response => {
                    const items = response.data || [];
                    if (items.length) {
                        showDropdown(items, editor);
                    } else {
                        hideDropdown();
                    }
                }).catch(() => hideDropdown());
            }, 250);
        };

        params.inputListeners.push(gameInputListener);

        // Keyboard navigation via keydown on the editor element
        extend(TextEditor.prototype, 'oncreate', function () {
            const editorEl = this.$('textarea, [contenteditable]')[0];
            if (editorEl) {
                editorEl.addEventListener('keydown', (e) => {
                    if (!isActive || !activeItems.length) return;

                    if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        selectedIndex = (selectedIndex + 1) % activeItems.length;
                        updateSelection();
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        selectedIndex = (selectedIndex - 1 + activeItems.length) % activeItems.length;
                        updateSelection();
                    } else if (e.key === 'Enter' || e.key === 'Tab') {
                        e.preventDefault();
                        selectItem(activeItems[selectedIndex]);
                    } else if (e.key === 'Escape') {
                        hideDropdown();
                    }
                });
            }
        });
    });
}
